import React from 'react';

export interface MetricChoice {
    value: string;
    label: string;
}

interface MetricPickerProps {
    choices: MetricChoice[];
    value: string;
    onChange: (value: string) => void;
}

/** "Visa i diagrammet": one pill per metric, the charted one filled; a radio group for assistive tech */
const MetricPicker: React.FC<MetricPickerProps> = ({ choices, value, onChange }) => (
    <div className="control-group metric-picker">
        <span id="metric-picker-label" className="control-label">Visa i diagrammet</span>
        <div className="metric-picker-pills" role="radiogroup" aria-labelledby="metric-picker-label">
            {choices.map(choice => (
                <button
                    key={choice.value}
                    type="button"
                    role="radio"
                    aria-checked={choice.value === value}
                    className={`metric-pill ${choice.value === value ? 'active' : ''}`}
                    onClick={() => onChange(choice.value)}
                >
                    {choice.label}
                </button>
            ))}
        </div>
    </div>
);

export default MetricPicker;
